module.exports = __webpack_public_path__ + "static/media/full-screen-w.d0ce7658.svg";